import { observer } from 'mobx-react';
import { emptyFragment } from '../../EmptyFragment';
import { T } from '../../Translations';
import Pagination from '../../components/Pagination';
import FlashError from '../FlashMessage/FlashError';
import { useLearningCollections } from './Dashboard/useLearningCollections';
import FiltersAndSorting from './FiltersAndSorting';
import Skeleton from './FiltersAndSorting/Skeleton';
import Headers from './Headers';
import LearningCollectionsList from './LearningCollectionsList';
import LCListSkeleton from './LearningCollectionsList/LCListSkeleton';
import LearningCollectionsStore from './Store';
interface Props {
  store: LearningCollectionsStore;
}

function LearningCollections({ store }: Props) {
  const { isLoading, error } = useLearningCollections(store);

  if (error) {
    console.error('Failed to load learning collection summaries:', error);
    return (
      <div className="max-w-clientPortalMaxWidth w-full mx-auto px-2.5 lg:px-12">
        <FlashError>
          <T kind="Unable to load learning collections. Please try again later." />
        </FlashError>
      </div>
    );
  }

  // Only show the full loading skeleton on initial load, not when filtering/sorting
  if (isLoading && store.state.data.isNothing()) {
    return (
      <>
        <Headers />
        <div className="max-w-clientPortalMaxWidth overflow-x-hidden w-full mx-auto">
          <>
            <Skeleton />
            <div className="py-5 px-2.5 lg:px-12">
              <LCListSkeleton />
            </div>
          </>
        </div>
      </>
    );
  }
  return (
    <>
      <Headers />
      <div className="max-w-clientPortalMaxWidth overflow-x-hidden w-full mx-auto">
        {store.state.data
          .map((d) => (
            <>
              <FiltersAndSorting store={store} data={d} />
              <div className="py-5 px-2.5 lg:px-12">
                {isLoading ? (
                  <div className="py-5 px-2.5 lg:px-12">
                    <LCListSkeleton />
                  </div>
                ) : (
                  <LearningCollectionsList learningCollectionSummariesResource={d} store={store} />
                )}
              </div>
              <div className="py-5 px-2.5 lg:px-12">
                <Pagination metadata={d.metadata} pageFn={store.changingPage} />
              </div>
            </>
          ))
          .getOrElse(emptyFragment)}
      </div>
    </>
  );
}

export default observer(LearningCollections);
